import { array, object, string, number } from 'yup'
import { safify } from '../utils/safify'

export const textStyles = array(
  object({
    font_role: string().required(),
    style: object({
      font_family: string(),
      font_weight: number(),
      line_height: number(),
      letter_spacing: number(),
    }),
  }),
)
  .default([])
  .meta({ autoFill: false })
  .transform(safify)
